import { parseDatum } from '@ps20-frontend/preis-lib';
import {
  BeamtenKennung,
  BeruflicheStellung,
  EinheitenArt,
  FamilienStand,
  SpartenType,
  TaasRsVmData,
  TaasVermieterBaustein,
} from '@ps20/bff-models';
import { VermietetesModalObjekt, VermietetesObjektEnum } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../appState';

const AUSLAENDISCHE_ADRESSE_PLZ_RISIKOORT = '99999';
export function generateBasicTaasRSVmData(state: IAppState): TaasRsVmData {
  const vermieterBausteine = generateVermieterBausteine(state.vermieteteCardObjekte);

  return {
    spartenType: SpartenType.RECHTSSCHUTZ_VERMIETUNG,
    salesProducts: null,
    familienstand: state.versicherungsnehmer.juristisch
      ? FamilienStand.FAMILIE
      : state.versicherungsnehmer.familienstand,
    geburtsdatumVN: parseDatum(state.versicherungsnehmer.geburtsdatum),
    anzVorschaeden: state.rechtsstreitigkeiten.anzahl,
    plzVN: state.risikoort.plz,
    beruflicheStellung: BeruflicheStellung.UNBEKANNT,
    beamtenKennung: BeamtenKennung.NICHT_BEAMTER,
    vermieterBausteine,
  };
}

export function generateVermieterBausteine(
  vermieteteObjekte: VermietetesModalObjekt[],
): Array<TaasVermieterBaustein> {
  return (
    vermieteteObjekte &&
    vermieteteObjekte.reduce((bausteinArray, vermieteteObjekt) => {
      const plzRisikoort = vermieteteObjekt.auslaendischeAdresse
        ? AUSLAENDISCHE_ADRESSE_PLZ_RISIKOORT
        : vermieteteObjekt.plz;

      if (vermieteteObjekt.grundstueckBebaut === VermietetesObjektEnum.BEBAUT) {
        if (vermieteteObjekt.wohneinheiten) {
          bausteinArray.push({
            plzRisikoort: plzRisikoort,
            einheitenArt: EinheitenArt.WOHNEINHEIT,
            anzahlVermieteteEinheiten: vermieteteObjekt.wohneinheiten,
            jahresBruttoMiete: vermieteteObjekt.bruttojahresmieteWohneinheiten,
            unbebauteFlaeche: 0,
            deltafaktor: vermieteteObjekt.deltafaktorWohnung,
            plzFaktor: vermieteteObjekt.plzFaktorWohnung,
            instanzId: vermieteteObjekt.instanzIdWohnung,
            auslaendischeAdresse: vermieteteObjekt.auslaendischeAdresse,
          });
        }
        if (vermieteteObjekt.gewerbeeinheiten) {
          bausteinArray.push({
            plzRisikoort: plzRisikoort,
            einheitenArt: EinheitenArt.GEWERBEEINHEIT,
            anzahlVermieteteEinheiten: vermieteteObjekt.gewerbeeinheiten,
            jahresBruttoMiete: vermieteteObjekt.bruttojahresmieteGewerbeeinheiten,
            unbebauteFlaeche: 0,
            deltafaktor: vermieteteObjekt.deltafaktorGewerbe,
            plzFaktor: vermieteteObjekt.plzFaktorGewerbe,
            instanzId: vermieteteObjekt.instanzIdGewerbe,
            auslaendischeAdresse: vermieteteObjekt.auslaendischeAdresse,
          });
        }
        if (vermieteteObjekt.stellplaetze) {
          bausteinArray.push({
            plzRisikoort: plzRisikoort,
            einheitenArt: EinheitenArt.GARAGE,
            anzahlVermieteteEinheiten: vermieteteObjekt.stellplaetze,
            jahresBruttoMiete: vermieteteObjekt.bruttojahresmieteStellplaetze,
            unbebauteFlaeche: 0,
            deltafaktor: vermieteteObjekt.deltafaktorGarage,
            plzFaktor: vermieteteObjekt.plzFaktorGarage,
            instanzId: vermieteteObjekt.instanzIdGarage,
            auslaendischeAdresse: vermieteteObjekt.auslaendischeAdresse,
          });
        }
      }

      if (vermieteteObjekt.grundstueckBebaut === VermietetesObjektEnum.UNBEBAUT) {
        bausteinArray.push({
          plzRisikoort: plzRisikoort,
          einheitenArt: EinheitenArt.UNBEBAUTES_GRUND_STUECK,
          anzahlVermieteteEinheiten: 1,
          unbebauteFlaeche: vermieteteObjekt.grundstueckFlaeche,
          jahresBruttoMiete: 0,
          deltafaktor: vermieteteObjekt.deltafaktorUnbebaut,
          plzFaktor: vermieteteObjekt.plzFaktorUnbebaut,
          instanzId: vermieteteObjekt.instanzIdUnbebaut,
          auslaendischeAdresse: vermieteteObjekt.auslaendischeAdresse,
        });
      }
      return bausteinArray;
    }, [])
  );
}
